import axios from "axios";
import { isAuthenticated } from "../service/api/AuthService";

const ApiClient = axios.create({
  baseURL: `${process.env.REACT_APP_SERVICE_PATH_ENV}/api/`,
  responseType: "json",
  withCredentials: false
});

ApiClient.interceptors.request.use(
  async config => {
    const userSession = await isAuthenticated();
    const token = userSession.getIdToken().getJwtToken();
    if (token) { config.headers['Authorization'] = token }
    return config;
  },
  error => {
    Promise.reject(error.response || error.message);
  }
);

export { ApiClient };




export const ApiClientPdf = axios.create({
  baseURL: `${process.env.REACT_APP_SERVICE_PATH_ENV}/api/`,
  responseType: "arraybuffer",
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/pdf'
  },
  withCredentials: false
});

ApiClientPdf.interceptors.request.use(
  config => {
    let loggedUser = sessionStorage.getItem("loggedUser")
    if (loggedUser) {
      let token = JSON.parse(loggedUser)?.token;
      if (token) { config.headers['Authorization'] = token }
    }
    return config;
  },
  error => {
    Promise.reject(error.response || error.message);
  }
);